import { motion } from "framer-motion";
import branded from "../../assests/images/branded.jpg";
import incentive from "../../assests/images/incentives.jpg";

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: "easeOut" },
  },
};



export default function ShowcaseSection() {
  return (
    <section className="bg-[#92abc4]/85 py-16">
      {/* Section Title */}
      <motion.h2
        className="text-center text-yellow-400 text-2xl md:text-3xl font-bold mb-12 px-4"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        Thoughtfully designed gifting solutions, tailored to your needs.
      </motion.h2>

      <div className="max-w-6xl mx-auto space-y-14 px-4">
        {/* Item 1 */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center"
          variants={itemVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <img
            src={branded}
            alt="Branded merchandise"
            className="rounded-lg w-full h-[260px] md:h-[320px] object-cover"
          />
          <h3 className="text-white text-xl md:text-2xl font-semibold text-center md:text-left">
            Branded Merchandise
          </h3>
        </motion.div>

        {/* Item 2 (reversed on desktop) */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center md:flex-row-reverse"
          variants={itemVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          
          <img
            src={incentive}
            alt="Recognition and incentives"
            className="rounded-lg w-full h-[260px] md:h-[320px] object-cover"
          />
          <h3 className="text-white text-xl md:text-2xl font-semibold text-center md:text-left">
            Recognition & Incentives Programmes
          </h3>
        </motion.div>
      </div>
    </section>
  );
}

